@switch (cardType) {
	@case (cardTypes.HORIZONTAL) {
		<ng-container *ngTemplateOutlet="horizontalCard"></ng-container>
	}
	@case (cardTypes.VERTICAL) {
		<ng-container *ngTemplateOutlet="vertical"></ng-container>
	}
	@case (cardTypes.FAVORITE) {
		<ng-container *ngTemplateOutlet="favoriteCard"></ng-container>
	}
	@case (cardTypes.MINI) {
		<ng-container *ngTemplateOutlet="miniCard"></ng-container>
	}
	@case (cardTypes.ADMIN) {
		<ng-container *ngTemplateOutlet="adminCard"></ng-container>
	}
	@case (cardTypes.ORIENTATION_FORM) {
		@if(cardTypeOrientation === cardTypes.HORIZONTAL) {
			<ng-container *ngTemplateOutlet="orientationFormHorizontal"></ng-container>
		} @else {
			<ng-container *ngTemplateOutlet="orientationForm"></ng-container>
		}
	}
}
<ng-template #horizontalCard>
	<div class="bg-accent-lighter card horizontalCard pointer" (click)="goToCourse()" matTooltipClass="custom-tooltip" [matTooltip]="!canAccessCourse ? (accessDeniedKey | translateWithKeys) : null">
		<div [ngClass]="{'relative': courseEnrollment?.completedPercentage === 100}">
			@if (courseEnrollment?.completedPercentage === 100) {
				<mat-icon svgIcon="check_icon_green" class="course-finished"></mat-icon>
			}
			<img class="horizontal-image" dynamicImage [baseImageSrc]="courseEnrollment?.image" [displayResolutions]="[RESOLUTIONS.sm]" alt="">
		</div>
		<div class="course-info-container">
			<div class="title-container ">
				<div class="flex row title-horizontal center w-100">
					<h2 class="title" [matTooltip]="courseEnrollment?.name"
					[matTooltipDisabled]="courseEnrollment?.name?.length < 40">{{courseEnrollment?.name | customTitleCase}}</h2>
					<button mat-icon-button (click)="markAsFavorite($event)">
						<mat-icon [svgIcon]="courseEnrollment.isFavorite ? 'favorite_filled' : 'favorite'"></mat-icon>
					</button>
				</div>
				<div class="course-info ">
					<ng-container *ngTemplateOutlet="courseInfo"></ng-container>
				</div>
				<div class="height-description-horizontal">
					<p class="description" [matTooltip]="courseEnrollment?.description"
					[matTooltipDisabled]="courseEnrollment?.description?.length < 150">{{courseEnrollment?.description}}</p>
				</div>
			</div>
			<div class="progress-bar-container">
				<ng-container *ngTemplateOutlet="progressBar"></ng-container>
				<div class="mr-12">
					<button class=" bg-primary-darker text-accent-lighter " mat-flat-button [disabled]="!canAccessCourse">{{( courseEnrollment?.completedPercentage === 0 ? 'course-creation.start' :  courseEnrollment?.completedPercentage === 100 ? 'course-creation.view' : 'course-creation.continue')| translateWithKeys}}</button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #vertical>
	<div [ngClass]="{'verticalCard': cardType === cardTypes.VERTICAL, 'favoriteCard':  cardType === cardTypes.FAVORITE }"
		class="bg-accent-lighter card">
		<div class="height-img" [ngClass]="{'relative': courseEnrollment?.completedPercentage === 100}">
			@if (courseEnrollment?.completedPercentage === 100) {
				<mat-icon svgIcon="check_icon_green" class="course-finished"></mat-icon>
			}
			<img [ngClass]="{'vertical-image': cardType === cardTypes.VERTICAL, 'favorite-image': cardType === cardTypes.FAVORITE, 'no-thumbnail': !courseEnrollment?.image}"
				dynamicImage fallback="../../../assets/images/thumbnail.png" [baseImageSrc]="courseEnrollment?.image" [displayResolutions]="[RESOLUTIONS.sm]">
		</div>
		<div [ngClass]="{ 'favorite-course-info-container' : cardType === cardTypes.FAVORITE}"
			class="vertical-course-info-container ">
			<div class="title-container pb-6">
				<h2 class="title truncate-title" [matTooltip]="courseEnrollment?.name"
				[matTooltipDisabled]="courseEnrollment?.name?.length < 40">{{courseEnrollment?.name | customTitleCase}}</h2>
			</div>
			<div class="course-info" [ngClass]="{'favorite-course-info': cardType === cardTypes.FAVORITE}">
				<ng-container *ngTemplateOutlet="courseInfo"></ng-container>
			</div>
			<p class="description" [matTooltip]="courseEnrollment?.description"
			[matTooltipDisabled]="courseEnrollment?.description?.length < 150">{{courseEnrollment?.description}}</p>
			<div class="progress-bar-container">
				<ng-container *ngTemplateOutlet="progressBar"></ng-container>
			</div>
			<div>
				<div class="vertical-btns-container" matTooltipClass="custom-tooltip" [matTooltip]="!canAccessCourse ? (accessDeniedKey | translateWithKeys) : null">
					<button class="vertical-view-btn bg-primary-darker text-accent-lighter " mat-flat-button (click)="goToCourse()" [disabled]="!canAccessCourse">{{( courseEnrollment?.completedPercentage === 0 ? 'course-creation.start' :  courseEnrollment?.completedPercentage === 100 ? 'course-creation.view' : 'course-creation.continue')| translateWithKeys}}</button>
					<button mat-icon-button (click)="markAsFavorite($event)"><mat-icon [svgIcon]="courseEnrollment.isFavorite ? 'favorite_filled' : 'favorite'"></mat-icon></button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #favoriteCard>
	<div class="favoriteCard bg-accent-lighter card">
		<img class="favorite-image" dynamicImage [baseImageSrc]="favorite?.courseImage" fallback="../../../assets/images/thumbnail.png" [displayResolutions]="[RESOLUTIONS.sm]" alt="{{favorite?.courseName}}">
		<div class="favorite-course-info-container vertical-course-info-container">
			<div class="title-container pb-6">
				@if(favorite.type === FavoriteTypeEnum.COURSE){
					<p class="caption-bold w250 text-accent ">{{favorite.categoryName | truncate: 45}} </p>
					<h2 class="title" [matTooltip]="favorite?.courseName"
					[matTooltipDisabled]="favorite?.courseName?.length < 40">{{favorite.courseName}}</h2>
				}
				@if(favorite.type === FavoriteTypeEnum.CHAPTER){
					<div class="caption-row">
						<p class="caption-bold text-accent ">{{favorite.categoryName | truncate: 22}}</p> <p class="dot text-accent ">·</p>
						 <p class="caption-bold text-accent ">{{favorite.courseName | truncate: 22}}</p>
					</div>
					<h2 class="title" [matTooltip]="favorite?.chapterName"
					[matTooltipDisabled]="favorite?.chapterName?.length < 40">{{favorite.chapterName}}</h2>
				}
			</div>
			<div class="course-info favorite-course-info">
				@if(favorite.type === FavoriteTypeEnum.COURSE){
					<ng-container *ngTemplateOutlet="favoriteInfo"></ng-container>
				}
				@if(favorite.type === FavoriteTypeEnum.CHAPTER){
					<ng-container *ngTemplateOutlet="chapterContent; context: { element: favorite }"></ng-container>
				}
			</div>
			<div>
				<div class="vertical-btns-container">
					<button class="vertical-view-btn bg-primary-darker text-accent-lighter " mat-flat-button (click)="goToCourse()">{{'course-creation.view' | translateWithKeys}}</button>
					<button mat-icon-button (click)="unmarkFavorite($event)"><mat-icon [svgIcon]="favorite.isDeleted ? 'favorite' : 'favorite_filled'"></mat-icon></button>
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #adminCard>
	<div class="column adminCard bg-accent-lighter card gap">
		<div class="flex space-between center title-spacing">
			<div class="title2 width-title">
				<h5 class="ellipsis title" [matTooltip]="course?.name"
				[matTooltipDisabled]="course?.name?.length < 35">{{course?.name | customTitleCase}}</h5>
				<div class="flex gap-6 width-adapt center" (click)="copyId($event,course?.id)">
					<span class="text-accent  ">{{ 'ID' + ' ' + course?.id
						}}</span>
					<mat-icon svgIcon="copy" [matTooltip]="'general.copy_to_clipboard' | translateWithKeys" class="copy-id-icon pointer"></mat-icon>
				</div>
			</div>
			<div>
				<app-three-dots [model]="course" [isCourse]="true" (action)="handleAction($event)"></app-three-dots>
			</div>
		</div>
		<div class="adminImg">
			<img dynamicImage fallback="../../../assets/images/thumbnail.png" [baseImageSrc]="course?.image" fall [displayResolutions]="[RESOLUTIONS.sm]" alt="{{course?.name}}" class="adminImg">
		</div>
		<div class="width-100">
			<ng-container *ngTemplateOutlet="courseInfoAdminCard"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #orientationForm>
	<div class="bg-accent-lighter card verticalCard">
		<div class="height-img">
			<img class="vertical-image" src="../../../assets/images/orientation-form.jpg">
		</div>
		<div class="vertical-course-info-container space-between">
			<div class="title-container pb-6 row-gap-10">
				<h2 class="title truncate-title">{{'category-creation.orientation_form' | translateWithKeys}}</h2>
				<p class="description">{{'category-creation.orientation_form_card_description' | translateWithKeys}}</p>
			</div>
			<div>
				<div class="orientation-form-btn w-100 mb-4" matTooltipClass="custom-tooltip" matTooltipPosition='above' [matTooltip]="!canCompleteForm ? ('general.cant_complete_form' | translateWithKeys) : null">
					@if (categoryEnrollment?.completedForm) {
						<button class="orientation-form-btn completed-form bg-primary-darker text-accent-lighter w-100 no-click" mat-flat-button>
							<mat-icon svgIcon="check_rounded"></mat-icon>
							<span>{{'general.completed' | translateWithKeys}}</span>
						</button>
					} @else {
						<button class="orientation-form-btn bg-primary-darker text-accent-lighter w-100" [disabled]="!canCompleteForm" mat-flat-button
						(click)="goToForm()">
							{{'category-creation.orientation_form_complete' | translateWithKeys}}
						</button>
					}
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #orientationFormHorizontal>
	<div class="bg-accent-lighter card horizontalCard">
		<div class="height-img">
			<img class="horizontal-image" src="../../../assets/images/orientation-form.jpg">
		</div>

		<div class="course-info-container space-between">
			<div class="title-container pb-6 row-gap-10">
				<div class="flex row title-horizontal center">
					<h2 class="title truncate-title">{{'category-creation.orientation_form' | translateWithKeys}}</h2>
				</div>
				<p class="description">{{'category-creation.orientation_form_card_description' | translateWithKeys}}</p>
			</div>
			<div class="end">
				<div  matTooltipClass="custom-tooltip-horizontal" matTooltipPosition='left' [matTooltip]="!canCompleteForm ? ('general.cant_complete_form' | translateWithKeys) : null">
					@if (categoryEnrollment?.completedForm) {
						<button class="orientation-form-btn-horizontal completed-form bg-primary-darker text-accent-lighter w-100 no-click" mat-flat-button>
							<mat-icon svgIcon="check_rounded"></mat-icon>
							<span>{{'general.completed' | translateWithKeys}}</span>
						</button>
					} @else {
						<button class="orientation-form-btn-horizontal bg-primary-darker text-accent-lighter w-100" [disabled]="!canCompleteForm" mat-flat-button
						(click)="goToForm()">
							{{'category-creation.orientation_form_complete' | translateWithKeys}}
						</button>
					}
				</div>
			</div>
		</div>
	</div>
</ng-template>

<ng-template #miniCard>
	<div class="miniCard flex column">
		<img class="mini-card-img" dynamicImage [baseImageSrc]="course?.image" [displayResolutions]="[RESOLUTIONS.sm]" alt="{{course?.name}}">
		<h2 class="title-mini-card truncate">{{course?.name | customTitleCase}}</h2>
		<p class="text-accent  ">{{course?.id}}</p>
	</div>
</ng-template>

<ng-template #chapterContent let-element="element">
	<div class="chips">
		@if (element?.video) {
			<mat-chip class="grey-chip bg-primary-lighter">
				<mat-icon class="chapter-table-chip icon-res " svgIcon="play"></mat-icon>
				 <span class="chip-text">Video</span>
			</mat-chip>
		}
		@if (element?.quiz) {
			<mat-chip class="grey-chip bg-primary-lighter">
				<mat-icon class="chapter-table-chip icon-res interrogation" svgIcon="quiz_interrogation"></mat-icon>
				<span class="chip-text">Quiz</span>
			</mat-chip>
		}
		</div>
</ng-template>

<ng-template #courseInfoAdminCard>
	<div class="flex course-info-admin height-admin-info-bg-accent-lighter card">
		<mat-chip class="chip" [ngClass]="course?.status === PublishStatusEnum.PUBLISHED ? 'published' : ''">
			{{'general.'+PublishStatusEnum[course?.status] | lowercase | translateWithKeys}}</mat-chip>
		<div class="flex center gap-6">
			<mat-icon svgIcon="calendar"></mat-icon>
			<p>{{(course?.createdAt.seconds * 1000) | appDate }}</p>
		</div>
		<div class="flex center gap-6">
			<mat-icon svgIcon="book"></mat-icon>
			<p>{{course?.totalChapters}}</p>
		</div>
		<div class="flex center gap-6" appTooltip [tooltipTemplate]="tooltipLanguage"
		[tooltipContext]="{ implicit: course?.languages }" [tooltipTop]="5">
			<mat-icon svgIcon="language"></mat-icon>
			<p>{{course?.languages.length}}</p>
		</div>
		@if (course?.duration) {
			<div class="flex center gap-6 shrink-0">
				<mat-icon svgIcon="clock"></mat-icon>
				<p>{{ course?.duration | timeFormat }}</p>
			</div>
		}
	</div>
</ng-template>

<ng-template #courseInfo>
	<div class="chapters">
		<mat-icon class="text-accent grey-icon" svgIcon="book"></mat-icon>
		<p class="text-accent ">{{courseEnrollment?.totalChapters}} {{(courseEnrollment?.totalChapters == 1 ? 'general.chapter' : 'general.chapters') | translateWithKeys}}</p>
	</div>
	<!-- <div class="duration">
		<mat-icon class="text-accent grey-icon" svgIcon="clock"></mat-icon>
		<p class="text-accent ">{{ courseEnrollment?.duration | timeFormat }}</p>
	</div> -->
</ng-template>

<ng-template #storeCourseInfo>
	<div class="chapters">
		<mat-icon class="text-accent" svgIcon="courses"></mat-icon>
		<p class="text-accent">{{category?.coursesQuantity}} {{(category?.coursesQuantity == 1 ? 'general.content' : 'general.contents') | translateWithKeys}}</p>
	</div>
	<div class="duration">
		<mat-icon class="text-accent" svgIcon="media"></mat-icon>
		<p class="text-accent ">{{category?.duration | timeFormat}}</p>
	</div>
</ng-template>

<ng-template #overviewCourseInfo>
	<div class="flex column gap-16">
		<div class="chapters">
			<mat-icon class="text-accent-darker" svgIcon="courses"></mat-icon>
			<p class="text-accent-darker">{{course?.totalChapters}} {{(course?.totalChapters == 1 ? 'general.content' : 'general.contents') | translateWithKeys}}</p>
		</div>
		<div class="duration">
			<mat-icon class="text-accent-darker" svgIcon="media"></mat-icon>
			<p class="text-accent-darker">{{course?.duration | timeFormat}}</p>
		</div>
		<div class="languages">
			<mat-icon class="text-accent-darker" svgIcon="world_black"></mat-icon>
			<div class="flex row">
				<p class="text-accent-darker">{{'general.languages' | translateWithKeys}}:</p>
				@for (language of course?.languages; track $index) {
					<p class="text-accent-darker">{{language.name}}</p>
				}
			</div>
		</div>
		<div class="flex gap-8">
			<mat-icon class="text-accent-darker" svgIcon="calendar"></mat-icon>
			<p class="text-accent-darker">{{'general.updated' | translateWithKeys}}: {{course?.updatedAt | appDate}}</p>
		</div>
	</div>
</ng-template>

<ng-template #overviewCourseInfo>
	<div class="flex column gap-16">
		<div class="chapters">
			<mat-icon class="text-accent-darker" svgIcon="courses"></mat-icon>
			<p class="text-accent-darker">{{course?.totalChapters}} {{(course?.totalChapters == 1 ? 'general.content' : 'general.contents') | translateWithKeys}}</p>
		</div>
		<div class="duration">
			<mat-icon class="text-accent-darker" svgIcon="media"></mat-icon>
			<p class="text-accent-darker">{{course?.duration | timeFormat}}</p>
		</div>
		<div class="languages">
			<mat-icon class="text-accent-darker" svgIcon="world_black"></mat-icon>
			<div class="flex row">
				<p class="text-accent-darker">{{'general.languages' | translateWithKeys}}:</p>
				@for (language of course?.languages; track $index) {
					<p class="text-accent-darker">{{language.name}}</p>
				}
			</div>
		</div>
		<div class="flex gap-8">
			<mat-icon class="text-accent-darker" svgIcon="calendar"></mat-icon>
			<p class="text-accent-darker">{{'general.updated' | translateWithKeys}}: {{course?.updatedAt | date: 'MM/dd/yyyy'}}</p>
		</div>
	</div>
</ng-template>

<!-- TODO: Make it generic. This is very similar to courseInfo -->
<ng-template #favoriteInfo>
	<div class="chapters">
		<mat-icon class="text-accent grey-icon" svgIcon="book"></mat-icon>
		<p class="text-accent ">{{favorite?.totalChapters}} {{(courseEnrollment?.totalChapters == 1 ? 'general.chapter' : 'general.chapters') | translateWithKeys}}</p>
	</div>
	<div class="duration">
		<mat-icon class="text-accent grey-icon" svgIcon="clock"></mat-icon>
		<p class="text-accent ">{{favorite?.duration | timeFormat}}</p>
	</div>
</ng-template>

<ng-template #progressBar>
	<div class="w-100 progress-container">
		<div class="progress pb-8">
			<p class="text-accent ">{{completedChapters}}/{{courseEnrollment?.totalChapters}}
				{{'general.chapters' | translateWithKeys}}</p>
			<p class="text-accent ">{{courseEnrollment?.completedPercentage}}%</p>
		</div>
		<mat-progress-bar class="progress-bar" [ngClass]="{'success-bar': courseEnrollment?.completedPercentage === 100}" mode="determinate"
			value="{{courseEnrollment?.completedPercentage}}"></mat-progress-bar>
	</div>
</ng-template>

<ng-template #tooltipLanguage let-languages="implicit">
	@if(course?.languages?.length){
		<div class="flex tooltip">
			@for(language of course.languages; track $index){
			<mat-chip class="colorLanguage">{{language?.name | translateWithKeys}}</mat-chip>
			}
		</div>

	}
</ng-template>
